var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import UserListSingle from "../../components/UserListSingle";
import { MenuOption } from "../../components/MenuOption";
import EditProfileModal from "../../components/modals/EditProfileModal";
import { logout } from "../../store/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import useChaseListNavigate from "../../hooks/useChaseListNavigate";
import useFetchUserFromList from "../../hooks/useFetchUserFromList";
import { toast, ToastContainer } from "react-toastify";
import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone';
import { FormGroup, FormControlLabel, Switch, Typography, Box, Divider } from '@mui/material';
import { setProfilePayload } from "../../store/slices/profileSlice";
import useUpdateProfile from "../../hooks/useUpdateProfile";
var Profile = function () {
    var chaseListNavigate = useChaseListNavigate();
    var userList = useSelector(function (state) { return state.userList.list; });
    var userId = useSelector(function (state) { return state.user.userId; });
    var _a = useState(false), userExistsInList = _a[0], setUserExistsInList = _a[1];
    var deductions = useSelector(function (state) { return state.profile.deductions; });
    var profileStatus = useSelector(function (state) { return state.profile.status; });
    var profileObj = useSelector(function (state) { return state.profile.profile; });
    var settings = useSelector(function (state) { var _a; return (_a = state.profile.profile) === null || _a === void 0 ? void 0 : _a.settings; });
    var _b = useUpdateProfile(), updateProfile = _b.updateProfile, isSaving = _b.loading;
    var parsedSettings = React.useMemo(function () {
        try {
            if (!settings)
                return {};
            return typeof settings === 'string' ? JSON.parse(settings) : settings;
        }
        catch (_a) {
            return {};
        }
    }, [settings]);
    var disabledDeductions = Array.isArray(parsedSettings === null || parsedSettings === void 0 ? void 0 : parsedSettings.disabled_deductions)
        ? parsedSettings.disabled_deductions
        : [];
    var handleToggleDeduction = function (id, enabled) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedDisabled, newSettings, updatedProfile;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedDisabled = enabled
                        ? disabledDeductions.filter(function (d) { return d !== id; })
                        : __spreadArray(__spreadArray([], disabledDeductions, true), [id], false);
                    newSettings = __assign(__assign({}, (parsedSettings || {})), { disabled_deductions: updatedDisabled });
                    if (!profileObj) return [3 /*break*/, 2];
                    console.log("Updating profile with new settings: ".concat(JSON.stringify(newSettings)));
                    updatedProfile = __assign(__assign({}, profileObj), { settings: newSettings });
                    dispatch(setProfilePayload({
                        status: profileStatus !== null && profileStatus !== void 0 ? profileStatus : 'success',
                        profile: updatedProfile,
                        deductions: deductions,
                    }));
                    return [4 /*yield*/, updateProfile({ settings: newSettings, id: userId })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var dispatch = useDispatch();
    var _c = useState(false), showEditProfileModal = _c[0], setShowEditProfileModal = _c[1];
    var statuses = useSelector(function (state) { return state.statuses.statuses; });
    var existsInList = useFetchUserFromList(userId, userList);
    var editProfileHandle = function (value) {
        setShowEditProfileModal(value);
    };
    var updateProfileHandle = function (error) {
        if (error == null) {
            toast.success('Updated Successfully');
        }
        else {
            toast.error(error);
        }
        setShowEditProfileModal(false);
    };
    var handleLogout = function () {
        dispatch(logout());
        chaseListNavigate('/');
    };
    useEffect(function () {
        if (existsInList) {
            var seniority = existsInList.seniority;
            var seniority_show = '';
            if (seniority < 1) {
                switch (seniority) {
                    case -3:
                        seniority_show = 'SS';
                        break;
                    case -2:
                        seniority_show = "CAS";
                        break;
                    default:
                        seniority_show = "JRY";
                        break;
                }
            }
            else {
                if (seniority >= 1 && seniority <= 5)
                    seniority_show = "".concat(seniority, " \u2022 U");
                if (seniority >= 6 && seniority <= 10)
                    seniority_show = "".concat(seniority, " \u2022 C");
                if (seniority >= 11 && seniority <= 15)
                    seniority_show = "".concat(seniority, " \u2022 B");
                if (seniority >= 16 && seniority <= 20)
                    seniority_show = "".concat(seniority, " \u2022 A");
                if (seniority >= 21 && seniority <= 25)
                    seniority_show = "".concat(seniority, " \u2022 AA");
                if (seniority >= 26)
                    seniority_show = "".concat(seniority, " \u2022 AAA");
            }
            setUserExistsInList({
                name: existsInList.name,
                date: existsInList.date,
                experience: seniority_show,
                status: statuses[existsInList.deleted],
                positions: existsInList.position,
                image: existsInList.imgUrl,
                union_member: existsInList.union_member,
                id: existsInList.id,
                updated_at: existsInList.updated_at
            });
        }
    }, [existsInList]);
    return (_jsxs("div", { children: [_jsx(ToastContainer, { position: 'top-right' }), showEditProfileModal === false && (_jsxs("div", { className: "flex flex-col overflow-hidden custom-content-height px-[18px] py-[18px] bg-white border border-[#00000014] rounded-[12px] relative pt-[60px] mr-1 ml-1 mb-1 box-container", children: [_jsxs("div", { className: "flex-1 overflow-y-auto pr-2 flex flex-col justify-end items-center", children: [userExistsInList && _jsx(UserListSingle, __assign({}, userExistsInList)), deductions && deductions.length > 0 && (_jsxs(Box, { className: "w-full mt-4", children: [_jsx(Typography, { variant: "subtitle1", className: "font-semibold mb-2 blue-text-color text-lg", children: "Deductions" }), _jsx(FormGroup, { children: deductions.map(function (d) {
                                            var isDisabled = disabledDeductions.includes(d.id);
                                            return (_jsx(FormControlLabel, { control: _jsx(Switch, { sx: {
                                                        '& .MuiSwitch-thumb': {
                                                            backgroundColor: '#00A190',
                                                        },
                                                        '& .Mui-checked': {
                                                            color: '#00A190',
                                                        },
                                                        '& .Mui-checked + .MuiSwitch-track': {
                                                            backgroundColor: '#00A190',
                                                        },
                                                    }, checked: !isDisabled, onChange: function (e) { return handleToggleDeduction(d.id, e.target.checked); } }), label: "".concat(d.label, " (").concat(d.amount, "%)") }, d.id));
                                        }) }), _jsx(Divider, { className: "mt-2" })] })), _jsx("div", { onClick: function () { return editProfileHandle(true); }, className: " w-full", children: _jsx(MenuOption, { icon: _jsx(AccountCircleTwoToneIcon, { className: "w-6 h-6 green-text-color" }), label: "Edit Profile", hasArrow: true }) })] }), _jsx("div", { className: "pt-4", children: _jsx("button", { className: 'logout_btn w-full font-semibold', onClick: handleLogout, children: "Logout" }) })] })), showEditProfileModal === true && (_jsx(EditProfileModal, { closeModal: function () { return editProfileHandle(false); }, saveProfileHandle: updateProfileHandle }))] }));
};
export default Profile;
